import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../../utils/axiosSetup.js';
import Pagination from '../layouts/pagination.jsx';
// import DeleteComponent from '../../action/delete.jsx';
import ViewProject from './sections/view.jsx';
import Swal from 'sweetalert2';
import ExcelExport from './sections/export.jsx';


const CompletedProjects = () => {
    const [projects, setProjects] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [projectId, setProjectId] = useState(null);
    const [filterText, setFilterText] = useState('');
    const [channels, setChannels] = useState([]);
    const [selectedChannel, setSelectedChannel] = useState('');
    const [clients, setClients] = useState([]);
    const [selectedClient, setSelectedClient] = useState('');
    const [exportProjects, setExportProjects] = useState([]);

    const fetchExportEmployees = async () => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/projects?project=completed`)
            .then(response => {
                setExportProjects(response.data.data);
            })
            .catch(error => {
                console.error("Error fetching projects!", error);
                setExportProjects([]);
            });
    };

    const fetchProjects = async (currentPage) => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/projects?project=completed&page=${currentPage + 1}`)
            .then(response => {
                setProjects(response.data.data);
                setPageCount(Math.ceil(response.data.meta.pagination.total / response.data.meta.pagination.per_page));
            })
            .catch(error => {
                console.error("Error fetching projects!", error);
                setProjects([]);
            });
    };

    const fetchChannels = async () => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/channels`)
            .then(response => {
                setChannels(response.data.data);
            })
            .catch(error => {
                setChannels([]);
            });
    };

    const fetchClients = async () => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/clients`)
            .then(response => {
                setClients(response.data.data);
            })
            .catch(error => {
                console.error('Error fetching clients', error);
                setClients([]);
            });
    }

    useEffect(() => {
        fetchProjects(currentPage);
        fetchChannels();
        fetchClients();
        fetchExportEmployees();
    }, [currentPage]);
    
    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
    };

    // Search input handler
    const filteredItems = projects.filter((item) => {
        var client = parseInt(selectedClient);
        var channel = parseInt(selectedChannel);
        const matchesName = item.title.toLowerCase().includes(filterText.toLowerCase());
        const matchesClient = client ? parseInt(item.client_id) === client : true;
        const matchesChannel = channel ? parseInt(item.channel_id) === channel : true;
        return matchesName && matchesChannel && matchesClient;    
    });

    const updateStatus = async ({pId, status}) => {
        const isConfirm = await Swal.fire({
            title: 'Are you sure?',
            text: "You want to change status!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: '&nbsp;&nbsp;&nbsp; Yes &nbsp;&nbsp;&nbsp;'
        }).then((result) => {
            return result.isConfirmed
        });

        if(!isConfirm){
            return;
        }

        axiosInstance.post(`${process.env.REACT_APP_API_URL}/project/status/${pId}`,{
                status: status,
            })
            .then(({data})=>{
                Swal.fire({icon:"success", text:data.message});
                fetchProjects();
            }).catch(({response:{data}})=>{
                Swal.fire({text:data.message, icon:"error"});
            });
    };
    
    return(
        <>
            <div className="content container-fluid">
                <div className="page-header">
                    <div className="row align-items-center timeLog">
                        <div className="col">
                            <h3 className="page-title">Completed Projects</h3>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Dashboard</Link></li>
                                <li className="breadcrumb-item active">Completed Projects</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-3 mb-3">
                        <select className="form-control"
                            value={selectedChannel}
                            onChange={(event) => {setSelectedChannel(event.target.value)}}>
                                <option value="">Select Channel</option>
                                {channels.map(channel => (
                                    <option key={channel.id} value={channel.id}>{channel.name}</option>
                                ))}
                        </select>
                    </div>
                    <div className="col-md-3 mb-3">
                        <select className="form-control"
                            value={selectedClient}
                            onChange={(event) => {setSelectedClient(event.target.value)}}>
                                <option value="">Select Client</option>
                                {clients.map(client => (
                                    <option key={client.id} value={client.id}>{client.name}</option>
                                ))}
                        </select>
                    </div>
                    <div className="col-md-3 mb-3">
                        <input className="form-control" type="text"
                            placeholder="Search project..." aria-label="Search Input"
                            value={filterText} onChange={(event)=>{
                                setFilterText(event.target.value)
                            }} />
                    </div>
                    <div className="col-md-3 mb-3 empInput" align="right">
                        <ExcelExport status="2" data={exportProjects} fileName="CompletedProject" />
                    </div>
                </div>

                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="table-responsive">
                                    <table className="table table-striped custom-table">
                                        <thead>
                                            <tr>
                                                <th>Channel Name</th>
                                                <th>Client Name</th>
                                                <th>Project Name</th>
                                                <th>Team Lead</th>
                                                <th>Project Created</th>
                                                <th>Completed Date</th>
                                                <th>Status</th>
                                                <th className="text-end">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                filteredItems.length > 0 ? (
                                                    filteredItems.map((project) => (
                                                        <tr key={project.id}>
                                                            <td>{project.channel_name}</td>
                                                            <td>{project.client_name}</td>
                                                            <td>{project.title}</td>
                                                            <td>{project.team_lead_name}</td>
                                                            <td>{project.startdate}</td>
                                                            <td>{project.updated_at}</td>
                                                            <td>
                                                                <div className="dropdown action-label">
                                                                    <Link className="btn btn-white btn-sm btn-rounded dropdown-toggle" to="#" data-bs-toggle="dropdown" aria-expanded="false">
                                                                        {project.status === '1' &&
                                                                            <><i className="fa-regular fa-circle-dot text-success"></i> Active</>
                                                                        }
                                                                        {project.status === '3' &&
                                                                            <><i className="fa-regular fa-circle-dot text-purple"></i> On Hold</>
                                                                        }
                                                                        {project.status === '2' &&
                                                                            <><i className="fa-regular fa-circle-dot text-info"></i> Completed</>
                                                                        }
                                                                        {project.status === '4' &&
                                                                            <><i className="fa-regular fa-circle-dot text-danger"></i> Inactive</>
                                                                        }
                                                                    </Link>
                                                                    <div className="dropdown-menu dropdown-menu-right">
                                                                        {project.status !== '1' &&
                                                                            <Link className="dropdown-item" to="#" onClick={() => updateStatus({ pId: project.id, status: '1' })}>
                                                                                <i className="fa-regular fa-circle-dot text-success"></i> Active
                                                                            </Link>
                                                                        }
                                                                        {project.status !== '3' &&
                                                                            <Link className="dropdown-item" to="#" onClick={() => updateStatus({ pId: project.id, status: '3' })}>
                                                                                <i className="fa-regular fa-circle-dot text-purple"></i> On Hold
                                                                            </Link>
                                                                        }
                                                                        {project.status !== '2' &&
                                                                            <Link className="dropdown-item" to="#" onClick={() => updateStatus({ pId: project.id, status: '2' })}>
                                                                                <i className="fa-regular fa-circle-dot text-info"></i> Completed
                                                                            </Link>
                                                                        }
                                                                        {project.status !== '4' &&
                                                                            <Link className="dropdown-item" to="#" onClick={() => updateStatus({ pId: project.id, status: '4' })}>
                                                                                <i className="fa-regular fa-circle-dot text-danger"></i> Inactive
                                                                            </Link>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </td>  
                                                            <td className="text-end">
                                                                <div className="dropdown dropdown-action">
                                                                    <Link to="#" className="action-icon dropdown-toggle"
                                                                        data-bs-toggle="dropdown" aria-expanded="false"
                                                                            onClick={() => setProjectId(`${project.id}`)}>
                                                                            <i className="material-icons">more_vert</i></Link>
                                                                    <div className="dropdown-menu dropdown-menu-right">
                                                                        <Link className="dropdown-item" to="#" data-bs-toggle="modal"
                                                                            data-bs-target={`#view_project_${project.id}`}>
                                                                                <i className="fa-solid fa-eye m-r-5"></i> View</Link>
                                                                            {/* <DeleteComponent 
                                                                                url = "projects"
                                                                                id = {project.id}
                                                                                fetchData={fetchProjects} /> */}
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="8">No records found</td>
                                                    </tr>
                                                ) 
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Pagination pageCount={pageCount} handlePageClick={handlePageClick}/>
            </div>

            <ViewProject projectId={projectId} />
        </>
    );
}

export default CompletedProjects